import {CALL_API} from 'redux-api-middleware';
import {ENDPOINT_ATTACHMENT} from 'common/endpoints';
import _ from 'lodash';
import {commonJwtHeader, commonJwtHeaderNoCT, encode} from 'common/utils';
import {
  API_ATTACHMENT_UPLOAD_REQUEST,
  API_ATTACHMENT_UPLOAD_SUCCESS,
  API_ATTACHMENT_UPLOAD_FAILURE,
  API_ATTACHMENT_GET_REQUEST,
  API_ATTACHMENT_GET_SUCCESS,
  API_ATTACHMENT_GET_FAILURE,
  API_ATTACHMENT_DELETE_REQUEST,
  API_ATTACHMENT_DELETE_SUCCESS,
  API_ATTACHMENT_DELETE_FAILURE,
} from 'common/types';

export default {
  retrieveAttachmentsForEntity: (token, entityId, entityType, filterOptions) => {
    const filterStrings = _.map(filterOptions, (option, optionKey) => {
      return `${optionKey}=${option}`;
    });
    const attachmentType = _.get(filterOptions, 'attachmentType');
    const excludeAttachmentTypes = _.get(filterOptions, 'excludeAttachmentTypes');

    const baseUrl = ENDPOINT_ATTACHMENT;
    const endpointToUse = !attachmentType
      ? excludeAttachmentTypes
        ? `${baseUrl}entity/${entityId}/entityType/${entityType}/excludeAttachmentTypes/${encode(
            excludeAttachmentTypes
          )}`
        : `${baseUrl}entity/${entityId}/entityType/${entityType}`
      : `${baseUrl}entity/${entityId}/entityType/${entityType}/attachmentType/${encode(
          attachmentType
        )}`;
    return {
      [CALL_API]: {
        endpoint: endpointToUse,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_ATTACHMENT_GET_REQUEST,
          API_ATTACHMENT_GET_SUCCESS,
          API_ATTACHMENT_GET_FAILURE,
        ],
      },
    };
  },
  deleteAttachment: (token, resourceId) => {
    const baseUrl = ENDPOINT_ATTACHMENT;

    return {
      [CALL_API]: {
        endpoint: `${baseUrl}resource/${encodeURIComponent(resourceId)}`,
        headers: commonJwtHeader(),
        method: 'DELETE',
        types: [
          API_ATTACHMENT_DELETE_REQUEST,
          API_ATTACHMENT_DELETE_SUCCESS,
          API_ATTACHMENT_DELETE_FAILURE,
        ],
      },
    };
  },
  uploadAttachment: (token, formData) => {
    const baseUrl = ENDPOINT_ATTACHMENT;

    return {
      [CALL_API]: {
        endpoint: `${baseUrl}save`,
        headers: commonJwtHeaderNoCT(),
        method: 'POST',
        body: formData,
        types: [
          API_ATTACHMENT_UPLOAD_REQUEST,
          API_ATTACHMENT_UPLOAD_SUCCESS,
          API_ATTACHMENT_UPLOAD_FAILURE,
        ],
      },
    };
  },
  updateDescription: (token, formData) => {
    const baseUrl = ENDPOINT_ATTACHMENT;

    let endpoint, method;
    endpoint = `${baseUrl}description`;
    method = 'PATCH';
    return {
      [CALL_API]: {
        endpoint,
        headers: commonJwtHeader(),
        method,
        body: formData,
        types: [
          API_ATTACHMENT_UPLOAD_REQUEST,
          API_ATTACHMENT_UPLOAD_SUCCESS,
          API_ATTACHMENT_UPLOAD_FAILURE,
        ],
      },
    };
  },
};
